import axios from "axios";
import { BASE_URL } from "./common/api_constants";

const customAxios = axios.create({
  baseURL: BASE_URL,
});

const requestHandler = (request) => {
  const token = localStorage.getItem("token");

  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  // else: no token yet — LaunchProvider hasn't completed initSession. The
  // first call will 401 until the JWT lands in localStorage.
  return request;
};

const responseHandler = (response) => {
  if (response.status === 401) {
    // localStorage.clear();
    // window.location.reload("/");
  }
  return response;
};

const requestErrorHandler = (error) => {
  return Promise.reject(error);
};

const responseErrorHandler = (error) => {
  if (error.response) {
    if (error.response.status === 401) {
      // localStorage.clear();
      // window.location.reload("/");
      return Promise.reject(error);
    }
  }
  return Promise.reject(error);
};

customAxios.interceptors.request.use(
  (request) => requestHandler(request),
  (error) => requestErrorHandler(error)
);

customAxios.interceptors.response.use(
  (response) => responseHandler(response),
  responseErrorHandler
);

export default customAxios;
